var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62788 15.2567C3.42325 15.2567 0 11.8335 0 7.62886C0 3.42422 3.42325 0.000976562 7.62788 0.000976562C11.8325 0.000976562 15.2558 3.42422 15.2558 7.62886C15.2558 11.8335 11.8325 15.2567 7.62788 15.2567ZM7.62788 1.11725C4.03348 1.11725 1.11628 4.04189 1.11628 7.62886C1.11628 11.2158 4.03348 14.1405 7.62788 14.1405C11.2223 14.1405 14.1395 11.2158 14.1395 7.62886C14.1395 4.04189 11.2223 1.11725 7.62788 1.11725Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4402 16.0007C15.2988 16.0007 15.1574 15.9486 15.0457 15.837L13.5574 14.3486C13.3416 14.1328 13.3416 13.7756 13.5574 13.5598C13.7732 13.344 14.1304 13.344 14.3462 13.5598L15.8346 15.0482C16.0504 15.264 16.0504 15.6212 15.8346 15.837C15.7229 15.9486 15.5815 16.0007 15.4402 16.0007Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconDash);
export default __webpack_public_path__ + "static/media/searchIconDash.bf02727ae73afeb61b7bcea58394f7c7.svg";
export { ForwardRef as ReactComponent };